export var CompressionMethod;
(function (CompressionMethod) {
    CompressionMethod[CompressionMethod["None"] = 0] = "None";
    CompressionMethod[CompressionMethod["Deflate"] = 1] = "Deflate";
    CompressionMethod[CompressionMethod["LZMA"] = 2] = "LZMA";
})(CompressionMethod || (CompressionMethod = {}));
